// Stored values shown as words. t() of a stored value returns it as it is
// in English ("fixed_term"), so the page asks for the word instead and
// translates that. A value not listed here is shown as it is.
export const CONTRACT_TYPE_LABELS = {
  'full-time': 'Full-Time',
  'part-time': 'Part-Time',
  contractor: 'Contractor',
  temporary: 'Temporary',
  permanent: 'Permanent',
  fixed_term: 'Fixed Term',
};

export const PAYMENT_STRUCTURE_LABELS = {
  hourly: 'Hourly',
  monthly: 'Monthly',
};

export const CALCULATION_TYPE_LABELS = {
  fixed: 'Fixed Amount',
  percentage: 'Percentage',
};

export const labelOf = (labels, value) => labels[value] || value;
